import { Component, Input } from '@angular/core';
import { ReferenceDataLabels } from '../../../../lib/constants/reference-data-labels';

@Component({
  selector: 'boi-progress-stepper',
  templateUrl: './progress-stepper.component.html',
  styleUrls: ['./progress-stepper.component.scss']
})
export class ProgressStepperComponent {
  @Input() activeTab: any;
  @Input() sections: any;
  @Input() hasSubmitValidationError?: boolean;

  public referenceDataLabels = ReferenceDataLabels;
}
